import type { SpouseDeclarationSnapshot, SpouseSnapshot } from '../dependentDeduction/spouseSection/spouseSectionTypes';

/** Spouse tax details were collected in Family Info — Section 2 is confirm + employee income only. */
export function isSpouseDataFromFamilyInfo(
  spouse: SpouseSnapshot,
  decl: SpouseDeclarationSnapshot
): boolean {
  return (
    Boolean(spouse.fullName.trim()) &&
    spouse.empFamilyId != null &&
    (decl.sharedLivelihood === 'yes' || decl.sharedLivelihood === 'no') &&
    !decl.spouseAddedInSection
  );
}
